export default function MapEquipmentPopupDirective() {
  return {
    restrict: 'E',
    template: require('./popup.html'),
    transclude: false,
    controllerAs: 'vm',
    controller: MapEquipmentPopupController
  };

  function MapEquipmentPopupController($scope, mapService, $stateParams, usersService) {
    'ngInject';
    let vm = this;
    vm.popupEquipmentData = null;
    vm.profileImage = null;
    vm.hasImagesRights = hasImagesRights;
    vm.showLastCommDate = false;

    // ToDo: These watches need to be removed and equipment & loading need to passed into the component. Once using 1.5.8 we can use $onChange
    $scope.$watch(
      function() {
        return mapService.selectedEquipmentFull;
      },
      function(newVal) {
        if (!mapService.selectedEquipmentFull) return;
        if ($stateParams.equipmentId == newVal.id) {
          vm.popupEquipmentData = newVal;
        }
      }
    );

    $scope.$watch(
      function() {
        return mapService.assetLoading;
      },
      function(newVal) {
        vm.loading = newVal;
      }
    );

    function hasImagesRights() {
      return usersService.hasRequiredFeatures(['images']);
    }
  }
}
